<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<v-row>
							<v-col cols="12">
								<v-text-field
									label="Іденифікатор запиту"
									v-model.trim="params.id"
									outlined
									dense
									clearable
									hide-details="auto"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<!-- PDF -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->

				<!-- Excel -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->
			</v-list>
        </v-navigation-drawer>

		<v-container style="padding: 64px 0px 0px 256px;">
			<v-breadcrumbs :items="crumbs" divider="-" ></v-breadcrumbs>
			<v-card flat>
				<v-card-title class="font-weight-light">
					{{ title }}
				</v-card-title>

				<v-divider></v-divider>

				<v-card-text>
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th>Назва</th>
									<th>Значення</th>
								</tr>
							</thead>
							<tbody>
								<!-- <tr v-for="(item, index) in data.datasets.ds" :key="index">
									<td>{{ item.id }}</td>
									<td>{{ item.datecreate }}</td>
									<td>{{ item.TypeName }}</td>
									<td>{{ item.number }}</td>
									<td>{{ item.vin }}</td>
									<td>{{ item.BrandName }}</td>
									<td>{{ item.ModelName }}</td>
									<td>{{ item.UserName }}</td>
									<td>{{ item.OrganizationName }}</td>
								</tr> -->
								<tr v-for="(item, index) in itemss" :key="index">
									<td>{{ item.name }}</td>
									<td>{{ item.value }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
					
					<v-card v-if="registrations.length">
						<v-card-title>Реєстрація</v-card-title>
						<v-card-text>
							<v-simple-table dense>
								<template v-slot:default>
									<!-- <thead>
										<tr>
											<th>Назва</th>
											<th>Значення</th>
										</tr>
									</thead> -->
									<tbody>
										<tr v-for="(registration, index) in registrations" :key="index">
											<td>{{ registration.name }}</td>
											<td>{{ registration.value }}</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-card-text>
					</v-card>

					<v-card v-if="uses.length">
						<v-card-title>Умови використання</v-card-title>
						<v-card-text>
							<v-simple-table dense>
								<template v-slot:default>
									<!-- <thead>
										<tr>
											<th>Назва</th>
											<th>Значення</th>
										</tr>
									</thead> -->
									<tbody>
										<tr v-for="(use, index) in uses" :key="index">
											<td>{{ use.name }}</td>
											<td>{{ use.value }}</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-card-text>
					</v-card>

					<v-card v-if="factors.length">
						<v-card-title>Фактори впливу на ціну</v-card-title>
						<v-card-text>
							<v-simple-table dense>
								<template v-slot:default>
									<!-- <thead>
										<tr>
											<th>Назва</th>
											<th>Значення</th>
										</tr>
									</thead> -->
									<tbody>
										<tr v-for="(factor, index) in factors" :key="index">
											<td>{{ factor.name }}</td>
											<td>{{ factor.value }}</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-card-text>
					</v-card>

					<v-card v-for="(estimate, index) in estimates" :key="index">
						<v-card-title>Оцінка {{ estimate.id }}</v-card-title>
						<v-card-text>
							<v-simple-table dense>
								<template v-slot:default>
									<thead>
										<tr>
											<th>Назва</th>
											<th>Значення</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(item, index) in getEstimates(estimate)" :key="index">
											<td>{{ item.name }}</td>
											<td>{{ item.value }}</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>

							<v-card v-if="estimate.percentiles.length">
								<v-card-title>Процентілі</v-card-title>
								<v-card-text>
									<v-simple-table dense>
										<template v-slot:default>
											<!-- <thead>
												<tr>
													<th>Назва</th>
													<th>Значення</th>
												</tr>
											</thead> -->
											<tbody>
												<tr v-for="(percentile, index) in estimate.percentiles" :key="index">
													<td>{{ percentile.name }}</td>
													<td>{{ percentile.value }}</td>
												</tr>
											</tbody>
										</template>
									</v-simple-table>
								</v-card-text>
							</v-card>

							<v-card v-if="estimate.adverts.length">
								<v-card-title>Об'яви</v-card-title>
								<v-card-text>
									<v-simple-table dense>
										<template v-slot:default>
											<!-- <thead>
												<tr>
													<th>Назва</th>
													<th>Значення</th>
												</tr>
											</thead> -->
											<tbody>
												<tr v-for="(advert, index) in estimate.adverts" :key="index">
													<td>{{ advert.name }}</td>
													<td>{{ advert.value }}</td>
												</tr>
											</tbody>
										</template>
									</v-simple-table>
								</v-card-text>
							</v-card>

							<v-card v-if="estimate.prices.length">
								<v-card-title>Ціни</v-card-title>
								<v-card-text>
									<v-simple-table dense>
										<template v-slot:default>
											<thead>
												<tr>
													<th>ID</th>
													<th>Назва</th>
													<th>Ціна UAH</th>
													<th>Ціна USD</th>
													<th>Кількість</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(advert, index) in estimate.prices" :key="index">
													<td>{{ advert.id }}</td>
													<td>{{ advert.name }}</td>
													<td>{{ advert.priceUAH }}</td>
													<td>{{ advert.priceUSD }}</td>
													<td>{{ advert.cnt }}</td>
												</tr>
											</tbody>
										</template>
									</v-simple-table>
								</v-card-text>
							</v-card>
						</v-card-text>
					</v-card>

				</v-card-text>
			</v-card>
		</v-container>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<z-pdf ref="pdf" :code="code" :name="name"></z-pdf>
	</v-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/main'
// import downloadExcel from "vue-json-excel"

export default {
	mixins: [mixin],
	components: { },
	data: () => ({
		
	}),
	
	props: {
		code: 				{ type: String, default: 'VehicleRequestDetail' },
		name: 				{ type: String, default: 'Запит' },
		id: 				{ type: [Number, String] },
	},

	computed: {
		itemss() {
			let result = []

			//console.log(this.$options.name, 'items', 'data', this.data)

			if(this.data?.id) result.push({ code: 'id', name: 'ID', value: this.data.id })
			if(this.data?.datecreate) result.push({ code: 'datecreate', name: 'Дата', value: this.data.datecreate })
			if(this.data?.type?.name) result.push({ code: 'type', name: 'Тип', value: this.data.type.name })
			if(this.data?.code) result.push({ code: 'code', name: 'Код', value: this.data.code })
			if(this.data?.name) result.push({ code: 'name', name: 'Назва', value: this.data.name })
			if(this.data?.description) result.push({ code: 'description', name: 'Опис', value: this.data.description })
			if(this.data?.number) result.push({ code: 'number', name: 'number', value: this.data.number })
			if(this.data?.vin) result.push({ code: 'vin', name: 'vin', value: this.data.vin })
			if(this.data?.category?.name) result.push({ code: 'category', name: 'category', value: this.data.category.name })
			if(this.data?.brand?.name) result.push({ code: 'brand', name: 'brand', value: this.data.brand.name })
			if(this.data?.model?.name) result.push({ code: 'model', name: 'model', value: this.data.model.name })
			if(this.data?.generation?.name) result.push({ code: 'generation', name: 'generation', value: this.data.generation.name })
			if(this.data?.modification?.name) result.push({ code: 'modification', name: 'modification', value: this.data.modification.name })
			if(this.data?.bodystyle?.name) result.push({ code: 'bodystyle', name: 'bodystyle', value: this.data.bodystyle.name })
			if(this.data?.state?.name) result.push({ code: 'state', name: 'state', value: this.data.state.name })
			if(this.data?.driver?.name) result.push({ code: 'driver', name: 'driver', value: this.data.driver.name })
			if(this.data?.fuel?.name) result.push({ code: 'fuel', name: 'fuel', value: this.data.fuel.name })
			if(this.data?.gearbox?.name) result.push({ code: 'gearbox', name: 'gearbox', value: this.data.gearbox.name })
			//if(this.data?.options.name) result.push({ code: 'options', name: 'options', value: this.data.options.name })
			if(this.data?.color?.name) result.push({ code: 'color', name: 'color', value: this.data.color.name })
			if(this.data?.country?.name) result.push({ code: 'country', name: 'country', value: this.data.country.name })
			if(this.data?.marketregion?.name) result.push({ code: 'marketregion', name: 'marketregion', value: this.data.marketregion.name })
			if(this.data?.bargain) result.push({ code: 'bargain', name: 'bargain', value: this.data.bargain })
			if(this.data?.yearProd) result.push({ code: 'yearProd', name: 'yearProd', value: this.data.yearProd })
			if(this.data?.yearProdFrom) result.push({ code: 'yearProdFrom', name: 'yearProdFrom', value: this.data.yearProdFrom })
			if(this.data?.yearProdTo) result.push({ code: 'yearProdTo', name: 'yearProdTo', value: this.data.yearProdTo })
			if(this.data?.mileage) result.push({ code: 'mileage', name: 'mileage', value: this.data.mileage })
			if(this.data?.mileageFrom) result.push({ code: 'mileageFrom', name: 'mileageFrom', value: this.data.mileageFrom })
			if(this.data?.mileageTo) result.push({ code: 'mileageTo', name: 'mileageTo', value: this.data.mileageTo })
			if(this.data?.mileageAvgNorm) result.push({ code: 'mileageAvgNorm', name: 'mileageAvgNorm', value: this.data.mileageAvgNorm })
			if(this.data?.engineVolume) result.push({ code: 'engineVolume', name: 'engineVolume', value: this.data.engineVolume })
			if(this.data?.engineVolumeFrom) result.push({ code: 'engineVolumeFrom', name: 'engineVolumeFrom', value: this.data.engineVolumeFrom })
			if(this.data?.engineVolumeTo) result.push({ code: 'engineVolumeTo', name: 'engineVolumeTo', value: this.data.engineVolumeTo })
			if(this.data?.custom) result.push({ code: 'custom', name: 'custom', value: this.data.custom })
			if(this.data?.damage) result.push({ code: 'damage', name: 'damage', value: this.data.damage })
			if(this.data?.currency) result.push({ code: 'currency', name: 'currency', value: this.data.currency })
			if(this.data?.abroad) result.push({ code: 'abroad', name: 'abroad', value: this.data.abroad })
			if(this.data?.sellerType) result.push({ code: 'sellerType', name: 'sellerType', value: this.data.sellerType })
			if(this.data?.matchedCountry) result.push({ code: 'matchedCountry', name: 'matchedCountry', value: this.data.matchedCountry })
			if(this.data?.fuelRateTo) result.push({ code: 'fuelRateTo', name: 'fuelRateTo', value: this.data.fuelRateTo })
			if(this.data?.fuelRatesType) result.push({ code: 'fuelRatesType', name: 'fuelRatesType', value: this.data.fuelRatesType })
			if(this.data?.powerFrom) result.push({ code: 'powerFrom', name: 'powerFrom', value: this.data.powerFrom })
			if(this.data?.powerTo) result.push({ code: 'powerTo', name: 'powerTo', value: this.data?.powerTo })
			if(this.data?.sort) result.push({ code: 'sort', name: 'sort', value: this.data?.sort })
			if(this.data?.topPerPod) result.push({ code: 'topPerPod', name: 'topPerPod', value: this.data.topPerPod })
			if(this.data?.saledParam) result.push({ code: 'saledParam', name: 'saledParam', value: this.data.saledParam })
			if(this.data?.vinInclude) result.push({ code: 'vinInclude', name: 'vinInclude', value: this.data.vinInclude })
			if(this.data?.wheelFormulaId) result.push({ code: 'wheelFormulaId', name: 'wheelFormulaId', value: this.data.wheelFormulaId })
			if(this.data?.axleId) result.push({ code: 'axleId', name: 'axleId', value: this.data?.axleId })
			if(this.data?.onlyPhoto) result.push({ code: 'onlyPhoto', name: 'onlyPhoto', value: this.data.onlyPhoto })
			if(this.data?.onlyVideo) result.push({ code: 'onlyVideo', name: 'onlyVideo', value: this.data.onlyVideo })
			if(this.data?.countId) result.push({ code: 'countId', name: 'countId', value: this.data?.countId })
			if(this.data?.avgPriceUAH) result.push({ code: 'avgPriceUAH', name: 'avgPriceUAH', value: this.data.avgPriceUAH })
			if(this.data?.avgPriceUSD) result.push({ code: 'avgPriceUSD', name: 'avgPriceUSD', value: this.data.avgPriceUSD })
			if(this.data?.costAmvUAH) result.push({ code: 'costAmvUAH', name: 'costAmvUAH', value: this.data.costAmvUAH })
			if(this.data?.period) result.push({ code: 'period', name: 'period', value: this.data.period })
			if(this.data?.service?.name) result.push({ code: 'service', name: 'service', value: this.data.service.name })
			if(this.data?.user?.name) result.push({ code: 'user', name: 'user', value: this.data.user.name })



			/* if(this.data?.) result.push({ code: '', name: '', value: this.data?. })
			if(this.data?.) result.push({ code: '', name: '', value: this.data?. })
			if(this.data?.) result.push({ code: '', name: '', value: this.data?. }) */

			//console.log(this.$options.name, 'items', 'result', result)
			
			/*
   
    "estimates": [
        {
            "id": "31817",
            "code": "VehicleAvaragePriceStatistic",
            "name": null,
            "description": null,
            "total": null,
            "arithmeticMean": null,
            "interQuartileMean": null,
            "avgPriceUAH": null,
            "avgPriceUSD": null,
            "minPriceUAH": null,
            "minPriceUSD": null,
            "maxPriceUAH": null,
            "maxPriceUSD": null,
            "percentiles": [],
            "adverts": [],
            "prices": [
                {
                    "id": "90424",
                    "code": "2025-03",
                    "name": "2025-03",
                    "priceUAH": 1894519,
                    "priceUSD": 45707,
                    "cnt": null
                },
                {
                    "id": "90425",
                    "code": "2025-04",
                    "name": "2025-04",
                    "priceUAH": 1878353,
                    "priceUSD": 45317,
                    "cnt": null
                },
                {
                    "id": "90426",
                    "code": "2025-05",
                    "name": "2025-05",
                    "priceUAH": 1839142,
                    "priceUSD": 44371,
                    "cnt": null
                }
            ],
            "equipments": []
        }
    ],
    "registrations": [],
    "uses": [],
    "factors": []
			*/
			return result
		},

		estimates() {
			return this.data?.estimates ? this.data.estimates : []
		},

		registrations() {
			return this.data?.registrations ? this.data.registrations : []
		},

		uses() {
			return this.data?.uses ? this.data.uses : []
		},

		factors() {
			return this.data?.factors ? this.data.factors : []
		},
	},

	created() {
		//console.log(this.$options.name, 'created','id', this.id)

		//this.params.id = this.id ? this.id : 32544
		this.params.id = this.id ? this.id : null
	},

	methods: {
		clearData() {
			this.setData({})
		},

		onOK() {
			var that = this

			//console.log(this.$options.name, 'params.id', this.params.id)
			//console.log(this.$options.name, 'id', this.id)

			this.clearData()

			if (this.$refs.form.validate()) {
				//console.log(this.$options.name, 'onOK', 'VALID')
				//console.log(this.$options.name, 'params', this.urlParams())
				this.loading = true
				axios.get(`/vehicle/request/${this.params.id}`).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					that.setData(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
				});
			}
		},

		getEstimates(data) {
			let result = []

			if(data?.id) result.push({ code: 'id', name: 'ID', value: data.id })
			if(data?.code) result.push({ code: 'code', name: 'Код', value: data.code })
			if(data?.name) result.push({ code: 'name', name: 'Назва', value: data.name })
			if(data?.description) result.push({ code: 'description', name: 'Опис', value: data.description })
			if(data?.total) result.push({ code: 'total', name: 'total', value: data.total })
			if(data?.arithmeticMean) result.push({ code: 'arithmeticMean', name: 'arithmeticMean', value: data.arithmeticMean })
			if(data?.interQuartileMean) result.push({ code: 'interQuartileMean', name: 'interQuartileMean', value: data.interQuartileMean })
			if(data?.avgPriceUAH) result.push({ code: 'avgPriceUAH', name: 'avgPriceUAH', value: data.avgPriceUAH })
			if(data?.avgPriceUSD) result.push({ code: 'avgPriceUSD', name: 'avgPriceUSD', value: data.avgPriceUSD })
			if(data?.minPriceUAH) result.push({ code: 'minPriceUAH', name: 'minPriceUAH', value: data.minPriceUAH })
			if(data?.minPriceUSD) result.push({ code: 'minPriceUSD', name: 'minPriceUSD', value: data.minPriceUSD })
			if(data?.maxPriceUAH) result.push({ code: 'maxPriceUAH', name: 'maxPriceUAH', value: data.maxPriceUAH })
			if(data?.maxPriceUSD) result.push({ code: 'maxPriceUSD', name: 'maxPriceUSD', value: data.maxPriceUSD })

			return result
		},
	}
}
</script>